import React, { useContext } from "react";
import { AuthContext } from '../../contexts/AuthContext'
import { Col, Row, Button } from "reactstrap";
import Footer from "../../layout/Footer/Footer";
import Header from "../../layout/Header/Header";

function BotonesCompras() {
  const { user } = useContext(AuthContext);
  return (
    <>
          <Header />
          {user.menu_compras ?(
      <div className="container">
        <br />
        <br />
        <Row >
        <Col md={4} align="center">
          {user.menu_oc ?(
            <Button href="/ListadoOrdenesCompra" className="botonesMenu" color="success">
              <i class="fas fa-shopping-basket fa-7x"></i>
              <br />
              <br />
              Ordenes de Produccion
            </Button>
          ): <Button disabled className="botonesMenu" color="success">
          <i class="fas fa-shopping-basket fa-7x"></i>
          <br />
          <br />
          Ordenes de Produccion
        </Button> }
          </Col>
        <Col md={4} align="center">
          {user.menu_oc  ?(
            <Button href="/ListadoPendEmbarcar" className="botonesMenu" color="success">
              <i class="fas fa-plane-departure fa-7x"></i>
              <br />
              <br />
              Pendiente Embarcar
            </Button>
          ): <Button disabled className="botonesMenu" color="success">
          <i class="fas fa-plane-departure fa-7x"></i>
          <br />
          <br />
          Pendiente Embarcar
        </Button> }
          </Col>
          <Col md={4} align="center">
          {user.menu_oc  ?(
            <Button href="/ListadoEmbarques" className="botonesMenu" color="success">
              <i class="fas fa-ship fa-7x"></i>
              <br />
              <br />
              Embarques
            </Button>
          ): <Button disabled className="botonesMenu" color="success">
          <i class="fas fa-ship fa-7x"></i>
          <br />
          <br />
          Embarques
        </Button> }
          </Col>
        </Row>
        <br />
        <Row>
          <Col md={4} align="center">
          {user.menu_compras ?(
            <Button href="/ListadoPendRecibir" className="botonesMenu" color="success">
              <i class="fas fa-plane-arrival fa-7x"></i>
              <br />
              <br />
              Pendiente Recibir
            </Button>
          ): <Button disabled className="botonesMenu" color="success">
          <i class="fas fa-plane-arrival fa-7x"></i>
          <br />
          <br />
          Pendiente Recibir
        </Button> }
          </Col>
          <Col md={4} align="center">
          {user.menu_compras ?(
            <Button href="/ListadoCompras" className="botonesMenu" color="success">
              <i class="fas fa-cart-plus fa-7x"></i>
              <br />
              <br />
              Entradas
            </Button>
          ): <Button disabled className="botonesMenu" color="success">
          <i class="fas fa-cart-plus fa-7x"></i>
          <br />
          <br />
          Entradas
        </Button> }
          </Col>
        <Col md={4} align="center">
            {user.menu_proveedores ?(
            <Button href="/Proveedores" className="botonesMenu" color="success">
            <i class="fas fa-dolly fa-7x"></i>
              <br />
              <br />
              Proveedores
            </Button>
            ): <Button disabled className="botonesMenu" color="success">
            <i class="fas fa-dolly fa-7x"></i>
              <br />
              <br />
              Proveedores
            </Button> }
          </Col>
        </Row>
        <br/>
        <Row>
        <Col md={4} align="center">
            {user.menu_compras ?(
            <Button href="/ConceptosGastosEmbarques" className="botonesMenu" color="success">
            <i class="fas fa-bars fa-7x"></i>
              <br />
              <br />
              Conceptos Gastos <br /> Embarque
            </Button>
            ): <Button disabled className="botonesMenu" color="success">
            <i class="fas fa-bars fa-7x"></i>
              <br />
              <br />
              Conceptos Gastos <br /> Embarque
            </Button> }
          </Col>
         
        </Row>
      </div>
      ): undefined } 
      
    </>
  );
}

export default BotonesCompras;
